import React, { ReactNode, useEffect } from 'react';
import { FunctionComponent } from 'react';
import ReactModal from 'react-modal';
import LoadingOverlay from 'src/common/loading-overlay';

// Trying to match SH style modals
ReactModal.defaultStyles.overlay = { ...ReactModal.defaultStyles.overlay, zIndex: 1000, backgroundColor: 'rgba(119, 119, 119, 0.7)' };
ReactModal.defaultStyles.content = {
  ...ReactModal.defaultStyles.content,
  zIndex: 1001,
  borderRadius: 0,
  boxShadow: '0px 0px 20px -5px rgba(0,0,0,1)',
  padding: 0,
  border: '10px solid #ECECEB',
};

export interface Props extends ReactModal.Props {
  title: string;
  buttons: ReactNode;
  validationDisplay?: ReactNode;
  width: string | number;
  height: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;
  loading?: boolean;
  loadingText?: string;
}

// There's more, but this is all we need.
interface JQueryEventData {
  namespace: string;
  handler: never;
}

interface JQueryEventsData {
  keydown?: JQueryEventData[];
}

const Modal: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    if (props.isOpen) {
      const events = $(document).data('events') as JQueryEventsData;
      const handler = events?.keydown?.find((x) => x.namespace === 'fb')?.handler;
      $(document).off('keydown.fb');
      return () => {
        if (handler) {
          $(document).on('keydown.fb', handler);
        }
      };
    }
    return undefined;
  }, [props.isOpen]);
  return (
    <ReactModal
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={false}
      {...props}
      style={{
        content: {
          position: 'unset',
          inset: 'unset',
          ...props.style?.content,
        },
        overlay: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...props.style?.overlay,
        },
      }}
    >
      <LoadingOverlay loading={!!props.loading} message={props.loadingText}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: props.width,
            height: props.height,
            maxWidth: props.maxWidth,
            maxHeight: props.maxHeight,
            border: '1px solid #d9d9d9',
            padding: '0 5px',
          }}
        >
          <div style={{ flex: '0 0 auto' }}>
            <div className="blueTitle modalTitle" style={{ margin: 5, fontSize: '120%', padding: 5 }}>
              {props.title}
            </div>
            <hr />
          </div>
          <div style={{ padding: 5, flexGrow: 1, overflowX: 'hidden', overflowY: 'auto' }}>{props.children}</div>
          <div style={{ flex: '0 0 auto' }}>
            <hr style={{ margin: '5px 0' }} />
            {props.validationDisplay && <div className="validationDisplay">{props.validationDisplay}</div>}
            <div className="actionButtons">{props.buttons}</div>
          </div>
        </div>
      </LoadingOverlay>
    </ReactModal>
  );
};

export default Modal;
